// Firebase は添付を選んだ時だけ読み込む。静的 import にすると gstatic が読めない環境
// (広告ブロッカー・回線不調)でモジュール全体が止まり、ステップが開かず送信もできなくなる。
const FIREBASE_BASE = "https://www.gstatic.com/firebasejs/10.7.1";
let firebaseModules = null;
async function loadFirebase() {
  if (!firebaseModules) {
    firebaseModules = Promise.all([
      import(`${FIREBASE_BASE}/firebase-app.js`),
      import(`${FIREBASE_BASE}/firebase-storage.js`),
      import(`${FIREBASE_BASE}/firebase-auth.js`),
    ]).catch((error) => { firebaseModules = null; throw error; });
  }
  const [app, storage, auth] = await firebaseModules;
  return { ...app, ...storage, ...auth };
}

const firebaseConfig = { apiKey: "AIzaSyChmQt2UuguUQFo6hSLU_KBczgV6vpVHlo", authDomain: "photopri-uploads.firebaseapp.com", projectId: "photopri-uploads", storageBucket: "photopri-uploads.firebasestorage.app", messagingSenderId: "697919935874", appId: "1:697919935874:web:a910d4f3afd7124eac6b9b" };
const allowed = new Set(["jpg", "jpeg", "png", "webp", "gif", "heic", "heif", "tif", "tiff", "psd", "psb", "pdf", "ai", "eps", "zip"]);
const maxBytes = 500 * 1024 * 1024;
const DRAFT_KEY = "rf_inquiry_draft_v1";
const PAPER_INTEREST_MAX = 5;
const CATEGORY_HINTS = {
  estimate: "用紙・サイズ・枚数からお値段を確認できます",
  paper: "作品に合う用紙や加工をご提案します",
  before_order: "納期・データ形式・入稿方法など",
  after_order: "差し替え・キャンセル・配送・到着後のご連絡など",
  color: "校正プリントで色を合わせるサービスです",
  bring: "お手持ちの用紙に印刷します",
  other: "上記以外のお問い合わせ"
};

function hasRestorableInput(values) {
  if (!values || typeof values !== "object") return false;
  const filled = (value) => typeof value === "string" && value.trim() !== "" && value.trim() !== "未定";
  if ([values.body, values.prefecture, values.interestedPaper, values.consideredProduct, values.deadline, values.orderTopic].some(filled)) return true;
  return (values.estimateItems || []).some((item) => filled(item?.paper) || filled(item?.size) || filled(item?.customWidth) || filled(item?.customHeight) || filled(item?.frameType) || filled(item?.frameSpec) || filled(item?.frameColor) || filled(item?.aluminumColor) || filled(item?.aluminumGeta));
}
const ESTIMATE_ITEM_MAX = 5;
const DRAFT_TTL = 24 * 60 * 60 * 1000;
const bodyPlaceholders = {
  estimate: "複数の用紙・サイズをご検討の場合はこちらにご記入ください",
  paper: "作品の雰囲気や、目指したい仕上がりをお聞かせください",
  before_order: "納期・入稿データ・ご注文方法など、ご質問をご記入ください",
  after_order: "差し替え・キャンセル・配送・到着後のご連絡など、内容をご記入ください",
  color: "色調補正についてのご希望やご相談をご記入ください",
  bring: "お持ち込み用紙についての補足事項をご記入ください",
  other: "お問い合わせ内容をご記入ください"
};
let lastTimestamp = 0;

function fileSize(bytes) {
  return `${(bytes / 1024 / 1024).toFixed(bytes >= 100 * 1024 * 1024 ? 0 : 1)}MB`;
}

function safeName(name) {
  return String(name).replace(/[^A-Za-z0-9._\-\u3040-\u30ff\u3400-\u9fff]/g, "_");
}

function formatYen(value) {
  return `¥${Number(value).toLocaleString("ja-JP")}`;
}

function parseDimensions(title) {
  const match = String(title).match(/[（(]\s*(\d+(?:\.\d+)?)\s*[×xX]\s*(\d+(?:\.\d+)?)\s*[）)]/);
  return match ? [Number(match[1]), Number(match[2])].sort((a, b) => a - b) : null;
}

class InquiryForm {
  constructor(form) {
    this.form = form;
    this.root = form.closest("section") || document;
    this.files = [];
    this.typeInputs = [...form.querySelectorAll('[name="contact[お客様区分]"]')];
    this.categorySelect = form.querySelector("[data-rf-category]");
    this.categoryHint = form.querySelector("[data-rf-category-hint]");
    // 種類はプルダウン。option に data-key を持たせ、以降は「選ばれた option」を種類として扱う。
    this.categoryInputs = this.categorySelect ? [...this.categorySelect.options].filter((option) => option.value) : [];
    this.fileInput = form.querySelector("[data-rf-files]");
    this.fileList = form.querySelector("[data-rf-upload-list]");
    this.uploadError = form.querySelector("[data-rf-upload-error]");
    this.attachments = form.querySelector("[data-rf-attachments]");
    this.submitError = form.querySelector("[data-rf-submit-error]");
    this.submitButton = form.querySelector("[data-rf-submit]");
    this.submitLabel = form.querySelector("[data-rf-submit-label]");
    this.errorSummary = form.querySelector("[data-rf-error-summary]");
    this.inputSummary = form.querySelector("[data-rf-input-summary]");
    this.draftNotice = form.querySelector("[data-rf-draft-notice]");
    this.estimateItemsHost = form.querySelector("[data-rf-estimate-items]");
    this.estimateAdd = form.querySelector("[data-rf-estimate-add]");
    this.paperInterestValue = form.querySelector("[data-rf-paper-interest-value]");
    this.paperInterestList = form.querySelector("[data-rf-paper-interest-list]");
    this.paperInterestAdd = form.querySelector("[data-rf-paper-interest-add]");
    const dataNode = this.root.querySelector('[id^="rf-inq-papers-"]') || document.querySelector('[id^="rf-inq-papers-"]');
    try { this.papers = JSON.parse(dataNode?.textContent || "[]"); } catch (_) { this.papers = []; }
    const finishNode = this.root.querySelector('[id^="rf-inq-finishes-"]') || document.querySelector('[id^="rf-inq-finishes-"]');
    try { this.finishes = JSON.parse(finishNode?.textContent || "[]"); } catch (_) { this.finishes = []; }
    this.setup();
  }

  typeValue() {
    // 区分はページ(URL)で決まるため hidden input で入る。ラジオ運用に戻した場合も動くよう両対応。
    const hidden = this.typeInputs.find((input) => input.type === "hidden");
    if (hidden) return hidden.value || "";
    return this.typeInputs.find((input) => input.checked)?.value || "";
  }

  categoryInput() {
    return this.categoryInputs.find((option) => option.selected) || null;
  }

  categoryKey() {
    return this.categoryInput()?.dataset.key || "";
  }

  setup() {
    if (this.form.querySelector("[data-rf-posted-success]")) {
      this.removeDraft();
      return;
    }
    this.form.dataset.rfEnhanced = "true";
    this.form.noValidate = true;
    this.fillPaperOptions();
    this.applyInitialState();

    this.typeInputs.forEach((input) => input.addEventListener("change", () => this.update()));
    this.categorySelect?.addEventListener("change", () => { this.urlOpened = false; this.update(true); });
    this.estimateItemsHost?.addEventListener("change", (event) => this.handleEstimateChange(event));
    this.estimateItemsHost?.addEventListener("input", (event) => this.handleEstimateInput(event));
    this.estimateItemsHost?.addEventListener("click", (event) => this.handleEstimateClick(event));
    this.estimateAdd?.addEventListener("click", () => this.addEstimateItem());
    this.form.querySelector("[data-rf-quote-doc]")?.addEventListener("change", () => this.syncQuoteDoc());
    this.form.querySelector("[data-rf-order-digits]")?.addEventListener("input", (event) => this.syncOrderNumber(event.target));
    this.form.querySelector("[data-rf-order-topic]")?.addEventListener("change", () => this.updateOrderTopic());

    if (this.fileInput) {
      this.fileInput.addEventListener("change", () => this.addFiles(this.fileInput.files));
      const dropzone = this.form.querySelector("[data-rf-dropzone]");
      // 大きなドラッグ枠は CSS で隠し、1行の添付ボタンで選ぶ。PC ではボタンへのドロップも受ける。
      const attach = this.form.querySelector("[data-rf-attach]");
      attach?.addEventListener("click", () => this.fileInput.click());
      dropzone?.addEventListener("click", () => this.fileInput.click());
      dropzone?.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") { event.preventDefault(); this.fileInput.click(); }
      });
      [attach, dropzone].filter(Boolean).forEach((target) => {
        ["dragenter", "dragover"].forEach((type) => target.addEventListener(type, (event) => { event.preventDefault(); target.classList.add("rf-dragover"); }));
        ["dragleave", "drop"].forEach((type) => target.addEventListener(type, (event) => { event.preventDefault(); target.classList.remove("rf-dragover"); }));
        target.addEventListener("drop", (event) => this.addFiles(event.dataTransfer.files));
      });
    }
    this.form.querySelector("[data-rf-url-open]")?.addEventListener("click", () => this.openOptionalUrl());
    this.form.querySelector("[data-rf-summary-toggle]")?.addEventListener("click", () => this.toggleInputSummary());

    this.form.addEventListener("blur", (event) => this.validateOnBlur(event.target), true);
    this.form.addEventListener("input", (event) => this.handleFieldChange(event.target));
    this.form.addEventListener("change", (event) => this.handleFieldChange(event.target));
    this.form.addEventListener("submit", (event) => this.submit(event));
    this.form.querySelector("[data-rf-clear-draft]")?.addEventListener("click", () => this.clearDraftValues());
    this.setupFormError();
    this.paperInterestList?.addEventListener("change", (event) => { if (event.target.matches("[data-rf-paper-interest]")) this.syncPaperInterest(); });
    this.paperInterestList?.addEventListener("click", (event) => {
      const remove = event.target.closest("[data-rf-paper-interest-remove]");
      if (remove) this.removePaperInterestRow(remove.closest("[data-rf-paper-interest-row]"));
    });
    this.paperInterestAdd?.addEventListener("click", () => this.addPaperInterestRow());
    this.prepareEstimateItems();
    this.update();
    this.restoreDraft();
    this.prefill();
    this.update();
    this.updateInputSummary();
  }

  applyInitialState() {
    const params = new URLSearchParams(location.search);
    const urlType = params.get("type");
    const typeKey = ["corporate", "individual"].includes(urlType) ? urlType : this.form.dataset.defaultType;
    const typeValue = typeKey === "corporate" ? "法人・団体のお客様" : "個人のお客様";
    const typeInput = this.typeInputs.find((input) => input.value === typeValue);
    if (typeInput && typeInput.type !== "hidden") typeInput.checked = true;

    const urlCategory = params.get("category");
    const allowedCategories = ["estimate", "paper", "before_order", "after_order", "color", "bring", "other"];
    const initialCategory = allowedCategories.includes(urlCategory) ? urlCategory : (this.form.dataset.defaultCategory === "none" ? "" : this.form.dataset.defaultCategory);
    const categoryInput = this.categoryInputs.find((option) => option.dataset.key === initialCategory);
    if (categoryInput) categoryInput.selected = true;
  }

  update(reveal = false) {
    const key = this.categoryKey();
    const corporate = this.typeValue() === "法人・団体のお客様";
    const progressNote = this.form.querySelector("[data-rf-progress-note]");
    if (progressNote) progressNote.hidden = Boolean(key);
    this.updateCategoryCollapse();

    this.form.querySelectorAll("[data-rf-progressive]").forEach((section) => {
      const wasLocked = section.classList.contains("rf-locked-progressive");
      section.classList.toggle("rf-locked-progressive", !key);
      section.classList.toggle("rf-section-unlocked", Boolean(key));
      if (key && (reveal || wasLocked)) {
        section.classList.remove("rf-reveal");
        requestAnimationFrame(() => section.classList.add("rf-reveal"));
      }
    });

    this.form.querySelectorAll("[data-rf-group]").forEach((group) => {
      const active = group.dataset.rfGroup === "corporate" ? corporate : group.dataset.rfGroup === key;
      group.hidden = !active;
      group.querySelectorAll("input, select, textarea").forEach((field) => {
        field.disabled = !active;
        field.required = active && field.hasAttribute("data-required");
      });
    });

    this.form.querySelectorAll("[data-conditional-required]").forEach((field) => {
      const rules = field.dataset.conditionalRequired.split(",");
      field.required = rules.includes(key) || (rules.includes("corporate") && corporate) || (rules.includes("empty") && !key);
    });

    this.updateDynamicRequiredMarks(corporate, key);
    this.syncQuoteDoc();
    this.syncPaperInterest();
    this.estimateItems().forEach((item) => { this.updateSizes(item, false); this.updateSizeMode(item); this.updateFrameFields(item); this.updateAluminumFields(item); });
    this.syncEstimateValues();
    this.updateBodyPlaceholder();
    this.updateOrderTopic();
    this.updatePrice();
    this.updateFieldLabels();
    this.updateOptionalUrl();
    this.updateCompactSections();
    this.updateInputSummary();
    this.form.querySelectorAll(":disabled[aria-invalid]").forEach((field) => this.clearFieldError(field));
  }

  updateCompactSections() {
    this.form.querySelectorAll(".rf-section[data-rf-block]").forEach((section) => {
      const visible = [...section.querySelectorAll("input:not([type=hidden]), select, textarea")].filter((field) => {
        const hiddenAncestor = field.closest("[hidden]");
        return !field.disabled && (!hiddenAncestor || hiddenAncestor === section) && !field.closest(".rf-inq-honeypot");
      });
      section.hidden = visible.length === 0;
      const header = section.querySelector(".rf-section-header");
      if (header) header.hidden = section.dataset.rfBlock === "body" && visible.length === 1;
    });
  }

  updateOptionalUrl() {
    const group = this.form.querySelector("[data-rf-url-group]");
    const link = this.form.querySelector("[data-rf-url-open]");
    if (!group || !link) return;
    const active = Boolean(this.categoryKey());
    const optional = !group.querySelector("input")?.required;
    group.hidden = !active || (optional && !this.urlOpened);
    group.querySelectorAll("input").forEach((field) => { field.disabled = !active; });
    link.hidden = !active || !optional || this.urlOpened;
  }

  openOptionalUrl() { this.urlOpened = true; this.updateOptionalUrl(); this.form.querySelector("[data-rf-url-group] input")?.focus(); }

  toggleInputSummary() {
    this.summaryOpened = !this.summaryOpened;
    this.updateInputSummary();
  }

  updateAluminumFields(item, reset = false) {
    const group = item.querySelector("[data-rf-aluminum-fields]");
    const color = item.querySelector("[data-rf-aluminum-color]");
    const geta = item.querySelector("[data-rf-aluminum-geta]");
    if (!group || !color || !geta) return;
    const active = this.selectedFinish(item) === "アルミ複合板加工" && this.categoryKey() === "estimate";
    if (reset) { color.value = ""; geta.value = ""; }
    group.hidden = !active;
    [color, geta].forEach((field) => { field.disabled = !active; field.required = active; if (!active) field.value = ""; });
  }

  updateCategoryCollapse() {
    // プルダウンでは説明文が見えないので、選んだ種類の説明を下に1行だけ出す。
    const option = this.categoryInput();
    if (!this.categoryHint) return;
    const hint = option ? (CATEGORY_HINTS[option.dataset.key] || "") : "";
    this.categoryHint.textContent = hint;
    this.categoryHint.hidden = !hint;
  }

  updateDynamicRequiredMarks(corporate, key) {
    const phone = this.form.querySelector('[name="contact[電話番号]"]');
    const phoneLabel = phone && this.form.querySelector(`label[for="${phone.id}"]`);
    if (phoneLabel) phoneLabel.classList.remove("rf-inq-label-required");
    const bodyMark = this.form.querySelector(".rf-inq-body-required");
    if (bodyMark) bodyMark.textContent = ["paper", "before_order", "after_order", "other", ""].includes(key) ? "*" : "";
  }

  updateFieldLabels() {
    this.form.querySelectorAll('[data-rf-block="customer"] .rf-input-group, [data-rf-block="details"] .rf-input-group, [data-rf-block="files"] .rf-input-group, [data-rf-block="body"] .rf-input-group').forEach((group) => {
      const controls = [...group.querySelectorAll("input, select, textarea")].filter((field) => field.type !== "hidden" && field.type !== "file" && !field.disabled);
      if (!controls.length) return;
      const label = group.querySelector(":scope > .rf-label, :scope > .rf-inq-field-head > .rf-label, :scope > .rf-checkbox-label .rf-checkbox-text");
      if (!label) return;
      let marker = label.querySelector(":scope > [data-rf-field-status]") || label.querySelector(":scope > .rf-required, :scope > .rf-inq-body-required");
      if (!marker) {
        marker = document.createElement("span");
        label.append(" ", marker);
      }
      const required = controls.some((field) => field.required);
      marker.dataset.rfFieldStatus = "";
      marker.className = required ? "rf-required" : "rf-optional";
      marker.textContent = required ? "※" : "（任意）";
      marker.setAttribute("aria-hidden", "true");
    });
  }

  fillPaperOptions() {
    [...this.estimateItems(), ...this.paperInterestSelects()].map((item) => item.matches?.("[data-rf-estimate-item]") ? item.querySelector("[data-rf-estimate-paper]") : item).filter(Boolean).forEach((select) => {
      this.papers.forEach((paper) => select.add(new Option(paper.title, paper.title)));
    });
    this.syncPaperInterest();
  }

  estimateItems() { return this.estimateItemsHost ? [...this.estimateItemsHost.querySelectorAll("[data-rf-estimate-item]")] : []; }

  prepareEstimateItems() { this.estimateItems().forEach((item) => this.prepareEstimateItem(item)); this.renumberEstimateItems(); }

  prepareEstimateItem(item) {
    const index = this.estimateItems().indexOf(item) + 1;
    item.querySelectorAll("[id]").forEach((field) => { field.id = `${field.id.replace(/-\d+$/, "")}-${index}`; });
    item.querySelectorAll("label[for]").forEach((label) => { const field = item.querySelector(`#${CSS.escape(label.htmlFor.replace(/-\d+$/, "") + "-" + index)}`); if (field) label.htmlFor = field.id; });
    const modeName = `rf-inq-size-mode-${this.form.id || "form"}-${index}`;
    item.querySelectorAll("[data-rf-size-mode]").forEach((input) => { input.name = modeName; });
    const paper = item.querySelector("[data-rf-estimate-paper]");
    if (paper && paper.options.length <= 1) paper.append(...this.papers.map((entry) => new Option(entry.title, entry.title)));
    this.updateFrameFields(item);
  }

  updateFrameFields(item, resetType = false) {
    const group = item.querySelector("[data-rf-frame-fields]"); const type = item.querySelector("[data-rf-frame-type]"); const spec = item.querySelector("[data-rf-frame-spec]"); const color = item.querySelector("[data-rf-frame-color]");
    const active = this.selectedFinish(item) === "額装" && this.categoryKey() === "estimate";
    const products = this.finishes.find((entry) => entry.label === "額装")?.items || [];
    const fill = (select, values, previous) => { select.replaceChildren(new Option("選択してください", ""), ...values.map((value) => new Option(value, value)), new Option("未定・相談して決めたい", "未定・相談して決めたい")); select.value = values.includes(previous) || previous === "未定・相談して決めたい" ? previous : ""; };
    const oldType = type.value; const oldSpec = resetType ? "" : spec.value; const oldColor = resetType ? "" : color.value;
    fill(type, products.map((product) => product.title), oldType);
    const product = products.find((entry) => entry.title === type.value);
    fill(spec, product?.types?.specs || [], oldSpec);
    fill(color, product?.types?.colors || [], oldColor);
    group.hidden = !active;
    type.disabled = !active; spec.disabled = !active; color.disabled = !active || !product;
    type.required = active; spec.required = active; color.required = active && !!product;
    if (!active) { type.value = ""; spec.value = ""; color.value = ""; }
    this.updateFieldLabels();
  }

  restoreFrameFields(item, values) {
    item.querySelector("[data-rf-frame-type]").value = ""; item.querySelector("[data-rf-frame-spec]").value = ""; item.querySelector("[data-rf-frame-color]").value = "";
    this.updateFrameFields(item);
    const type = item.querySelector("[data-rf-frame-type]"); type.value = [...type.options].some((option) => option.value === values.frameType) ? values.frameType : "";
    this.updateFrameFields(item);
    const spec = item.querySelector("[data-rf-frame-spec]"); const color = item.querySelector("[data-rf-frame-color]");
    if ([...spec.options].some((option) => option.value === values.frameSpec)) spec.value = values.frameSpec;
    if ([...color.options].some((option) => option.value === values.frameColor)) color.value = values.frameColor;
  }

  restoreAluminumFields(item, values) {
    this.updateAluminumFields(item);
    const color = item.querySelector("[data-rf-aluminum-color]"); const geta = item.querySelector("[data-rf-aluminum-geta]");
    if (color && [...color.options].some((option) => option.value === values.aluminumColor)) color.value = values.aluminumColor;
    if (geta && [...geta.options].some((option) => option.value === values.aluminumGeta)) geta.value = values.aluminumGeta;
  }

  renumberEstimateItems() {
    const items = this.estimateItems();
    items.forEach((item, index) => {
      const number = index + 1;
      item.querySelector("[data-rf-estimate-item-title]").textContent = `品目 ${number}`;
      item.querySelector("[data-rf-estimate-item-head]").hidden = items.length === 1;
      item.querySelector("[data-rf-estimate-remove]").hidden = items.length === 1;
      this.prepareEstimateItem(item);
    });
    if (this.estimateAdd) { this.estimateAdd.hidden = items.length >= ESTIMATE_ITEM_MAX; this.estimateAdd.disabled = items.length >= ESTIMATE_ITEM_MAX; }
  }

  addEstimateItem(values = {}) {
    const items = this.estimateItems();
    if (!items.length || items.length >= ESTIMATE_ITEM_MAX) return;
    const item = items[0].cloneNode(true);
    item.querySelectorAll("input").forEach((input) => { if (input.type === "radio") input.checked = input.defaultChecked; else if (input.type === "number") input.value = input.defaultValue; });
    // 複製した時点では品目1と同じ name を持つ。そのまま append すると同じラジオグループに
    // 入り、品目1の「印刷のみ」「定形サイズ」が外れる（採番し直しても戻らない）。
    // 文書に入れる前に一意な name へ逃がしておく。
    const scratch = `rf-inq-new-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    item.querySelectorAll('input[type="radio"]').forEach((input) => { input.name = `${scratch}-${input.name}`; });
    item.querySelector("[data-rf-estimate-paper]").value = values.paper || "";
    item.querySelector("[data-rf-estimate-quantity]").value = values.quantity || "1";
    this.estimateItemsHost.append(item);
    this.renumberEstimateItems(); this.prepareEstimateItem(item); this.updateSizes(item, false);
    if (values.sizeMode === "custom") item.querySelector("[data-rf-size-mode][value=custom]").checked = true;
    this.updateSizeMode(item);
    item.querySelector("[data-rf-custom-width]").value = values.customWidth || "";
    item.querySelector("[data-rf-custom-height]").value = values.customHeight || "";
    if (values.size) item.querySelector("[data-rf-estimate-size]").value = values.size;
    if (values.finish) { const finish = item.querySelector("[data-rf-estimate-finish]"); if (finish && [...finish.options].some((option) => option.value === values.finish)) finish.value = values.finish; }
    this.restoreFrameFields(item, values);
    this.restoreAluminumFields(item, values);
    this.syncEstimateValues(); this.updatePrice();
  }

  removeEstimateItem(item) { if (this.estimateItems().length <= 1) return; item.remove(); this.renumberEstimateItems(); this.syncEstimateValues(); this.updatePrice(); this.saveDraft(); }

  handleEstimateClick(event) { const item = event.target.closest("[data-rf-estimate-item]"); if (!item) return; if (event.target.closest("[data-rf-estimate-remove]")) return this.removeEstimateItem(item); const button = event.target.closest("[data-rf-qty-minus], [data-rf-qty-plus]"); if (button) this.changeQuantity(item, button.matches("[data-rf-qty-plus]") ? 1 : -1); }
  handleEstimateChange(event) { const item = event.target.closest("[data-rf-estimate-item]"); if (!item) return; if (event.target.matches("[data-rf-estimate-paper]")) this.updateSizes(item); if (event.target.matches("[data-rf-size-mode]")) this.updateSizeMode(item); if (event.target.matches("[data-rf-estimate-finish], [data-rf-frame-type]")) this.updateFrameFields(item, event.target.matches("[data-rf-frame-type]")); if (event.target.matches("[data-rf-estimate-finish]")) this.updateAluminumFields(item, true); else this.updateAluminumFields(item); this.syncEstimateValues(); this.updatePrice(); }
  handleEstimateInput(event) { const item = event.target.closest("[data-rf-estimate-item]"); if (!item || !event.target.matches("[data-rf-custom-width], [data-rf-custom-height], [data-rf-estimate-quantity]")) return; this.syncEstimateValues(); this.updatePrice(); }

  paperInterestSelects() {
    return this.paperInterestList ? [...this.paperInterestList.querySelectorAll("[data-rf-paper-interest]")] : [];
  }

  addPaperInterestRow(value = "") {
    const rows = this.paperInterestList?.querySelectorAll("[data-rf-paper-interest-row]");
    if (!rows || rows.length >= PAPER_INTEREST_MAX) return null;
    const row = rows[0].cloneNode(true);
    const select = row.querySelector("[data-rf-paper-interest]");
    select.removeAttribute("id");
    select.replaceChildren(new Option("未定", "未定"), ...this.papers.map((paper) => new Option(paper.title, paper.title)));
    select.disabled = rows[0].querySelector("[data-rf-paper-interest]").disabled;
    if (value && [...select.options].some((option) => option.value === value)) select.value = value;
    this.paperInterestList.append(row);
    this.syncPaperInterest();
    if (!value) { this.saveDraft(); this.updateInputSummary(); select.focus(); }
    return select;
  }

  removePaperInterestRow(row) {
    if (!row || this.paperInterestList.querySelectorAll("[data-rf-paper-interest-row]").length <= 1) return;
    row.remove();
    this.syncPaperInterest();
    this.saveDraft();
    this.updateInputSummary();
    this.paperInterestAdd?.focus();
  }

  syncPaperInterest() {
    if (!this.paperInterestValue || !this.paperInterestList) return;
    const rows = [...this.paperInterestList.querySelectorAll("[data-rf-paper-interest-row]")];
    const picked = [];
    rows.forEach((row) => {
      const value = row.querySelector("[data-rf-paper-interest]")?.value || "";
      if (value && value !== "未定" && !picked.includes(value)) picked.push(value);
    });
    this.paperInterestValue.value = picked.length ? picked.join("、") : "未定";
    rows.forEach((row) => { row.querySelector("[data-rf-paper-interest-remove]").hidden = rows.length <= 1; });
    if (this.paperInterestAdd) {
      this.paperInterestAdd.hidden = rows.length >= PAPER_INTEREST_MAX;
      this.paperInterestAdd.disabled = rows.length >= PAPER_INTEREST_MAX;
    }
  }

  selectedPaper(item) {
    return this.papers.find((paper) => paper.title === item?.querySelector("[data-rf-estimate-paper]")?.value) || null;
  }

  availableSizes(item) {
    const paper = this.selectedPaper(item);
    const source = paper ? paper.sizes : this.papers.flatMap((item) => item.sizes || []);
    const unique = new Map();
    source.filter((size) => size.available).forEach((size) => { if (!unique.has(size.title)) unique.set(size.title, size); });
    return [...unique.values()];
  }

  updateSizes(item, reset = true) {
    const sizeSelect = item?.querySelector("[data-rf-estimate-size]"); if (!sizeSelect) return;
    const oldValue = sizeSelect.value;
    const sizes = this.availableSizes(item);
    const options = [new Option("未定", "未定"), ...sizes.map((size) => new Option(size.title, size.title))];
    const customOption = new Option("定形外サイズ", "定形外サイズ");
    customOption.hidden = true;
    options.push(customOption);
    sizeSelect.replaceChildren(...options);
    const canRestore = sizes.some((size) => size.title === oldValue) || oldValue === "定形外サイズ";
    sizeSelect.value = !reset && canRestore ? oldValue : (canRestore ? oldValue : "");
    this.updatePaperLink(item); this.updatePrice();
  }

  updatePaperLink(item) {
    const link = item?.querySelector("[data-rf-paper-link]"); const paper = this.selectedPaper(item);
    if (!link) return;
    link.hidden = !paper;
    if (paper) link.href = `/products/${encodeURIComponent(paper.handle)}`;
  }

  syncQuoteDoc() {
    const empty = this.form.querySelector("[data-rf-quote-doc-empty]");
    const box = this.form.querySelector("[data-rf-quote-doc]");
    if (!empty || !box) return;
    empty.disabled = box.disabled || box.checked;
  }

  sizeMode(item) { return item?.querySelector("[data-rf-size-mode]:checked")?.value || "standard"; }

  updateSizeMode(item) {
    const estimate = this.categoryKey() === "estimate";
    const custom = this.sizeMode(item) === "custom"; const standardBox = item?.querySelector("[data-rf-standard-size]"); const customBox = item?.querySelector("[data-rf-custom-size]"); const width = item?.querySelector("[data-rf-custom-width]"); const height = item?.querySelector("[data-rf-custom-height]"); const sizeSelect = item?.querySelector("[data-rf-estimate-size]");
    if (standardBox) standardBox.hidden = custom;
    if (customBox) customBox.hidden = !custom;
    [width, height].filter(Boolean).forEach((field) => { field.disabled = !estimate || !custom; field.required = estimate && custom; });
    if (sizeSelect) {
      sizeSelect.disabled = !estimate; sizeSelect.required = estimate;
      if (custom) {
        if (sizeSelect.value !== "定形外サイズ") item.dataset.lastStandardSize = sizeSelect.value;
        sizeSelect.value = "定形外サイズ";
      } else if (sizeSelect.value === "定形外サイズ") {
        sizeSelect.value = [...sizeSelect.options].some((option) => option.value === item.dataset.lastStandardSize) ? item.dataset.lastStandardSize : "";
      }
    }
    this.updatePrice();
  }

  changeQuantity(item, delta) {
    const input = item?.querySelector("[data-rf-estimate-quantity]");
    if (!input) return;
    input.value = String(Math.max(1, (Number.parseInt(input.value, 10) || 1) + delta));
    input.dispatchEvent(new Event("input", { bubbles: true }));
  }

  selectedFinish(item) { return item?.querySelector("[data-rf-estimate-finish]")?.value || ""; }

  matchingCustomSize(item, sizes) {
    const width = Number(item?.querySelector("[data-rf-custom-width]")?.value); const height = Number(item?.querySelector("[data-rf-custom-height]")?.value);
    if (!(width > 0 && height > 0)) return null;
    const wanted = [width, height].sort((a, b) => a - b);
    return sizes.map((size) => ({ ...size, dimensions: parseDimensions(size.title) }))
      .filter((size) => size.dimensions && wanted[0] <= size.dimensions[0] && wanted[1] <= size.dimensions[1])
      .sort((a, b) => (a.dimensions[0] * a.dimensions[1]) - (b.dimensions[0] * b.dimensions[1]))[0] || null;
  }

  finishQuote(label, sizeTitle) {
    // 仕上がり名に紐づく商品のうち、そのサイズで最も安い組み合わせを目安にする。
    const entry = this.finishes.find((item) => item.label === label);
    if (!entry || !sizeTitle) return null;
    let best = null;
    entry.items.forEach((item) => {
      item.sizes.forEach(([title, price]) => {
        if (title !== sizeTitle) return;
        if (!best || price < best.price) best = { price, handle: item.handle, title: item.title };
      });
    });
    return best;
  }

  updatePrice() {
    const panel = this.form.querySelector("[data-rf-price-panel]");
    if (!panel || this.categoryKey() !== "estimate") return;
    const quotes = this.estimateItems().map((item) => this.itemQuote(item));
    const priced = quotes.filter((quote) => quote.total != null);
    if (!priced.length) { panel.hidden = true; panel.replaceChildren(); return; }
    const title = document.createElement("div"); title.className = "rf-inq-price-title"; title.innerHTML = "<strong>お見積りの目安</strong><span>税込・送料別</span>";
    const rows = document.createElement("div"); rows.className = "rf-inq-price-items";
    quotes.forEach((quote, index) => {
      const row = document.createElement("section"); row.className = "rf-inq-price-item";
      const heading = document.createElement("p"); heading.className = "rf-inq-price-item-title"; heading.textContent = `品目${index + 1}　${quote.paper?.title || "未定"} / ${quote.sizeLabel}`; row.append(heading);
      if (quote.total != null) {
        row.append(this.priceRow("用紙", formatYen(quote.selected.price)));
        if (quote.finishQuote) row.append(this.priceRow(quote.finishQuote.title, formatYen(quote.finishQuote.price)));
        row.append(this.priceRow(`1枚あたり ${formatYen(quote.unitPrice)} × ${quote.quantity}枚`, formatYen(quote.total)));
      } else { row.append(this.priceRow("価格", quote.noEstimate ? "個別にお見積りします" : "目安なし")); }
      if (quote.custom && quote.selected) { const note = document.createElement("p"); note.className = "rf-inq-price-size-note"; note.textContent = `収まる規格サイズ ${quote.selected.title} の価格`; row.append(note); }
      rows.append(row);
    });
    const total = priced.reduce((sum, quote) => sum + quote.total, 0);
    const totalRow = this.priceRow(quotes.some((quote) => quote.noEstimate) ? "合計（アルミ複合板加工を除く）" : "合計", formatYen(total)); totalRow.classList.add("rf-inq-price-total");
    const children = [title, rows, totalRow];
    if (quotes.some((quote) => quote.finishQuote)) { const caution = document.createElement("p"); caution.className = "rf-inq-price-caution"; caution.textContent = "加工は最も安い組み合わせの金額です。マットや色の指定で変わります。"; children.push(caution); }
    if (quotes.length === 1 && priced.length === 1) { const quote = quotes[0]; const link = document.createElement("a"); link.className = "rf-inq-order-link"; link.href = `/products/${encodeURIComponent(quote.finishQuote ? quote.finishQuote.handle : quote.paper.handle)}`; link.textContent = quote.finishQuote ? `${quote.finishQuote.title}のページを見る` : "この内容で注文する"; children.push(link); }
    panel.replaceChildren(...children); panel.hidden = false;
  }

  priceRow(label, value) { const row = document.createElement("div"); row.className = "rf-inq-price-row"; const left = document.createElement("span"); const right = document.createElement("strong"); left.textContent = label; right.textContent = value; row.append(left, right); return row; }

  itemQuote(item) {
    const paper = this.selectedPaper(item); const sizes = this.availableSizes(item); const custom = this.sizeMode(item) === "custom"; const selected = custom ? this.matchingCustomSize(item, sizes) : sizes.find((size) => size.title === item.querySelector("[data-rf-estimate-size]")?.value); const finish = this.selectedFinish(item); const printOnly = finish === "印刷のみ" || finish === "未定・相談して決めたい"; const noEstimate = finish === "アルミ複合板加工"; const finishQuote = printOnly || noEstimate ? null : this.finishQuote(finish, selected?.title); const quantity = Math.max(1, Number.parseInt(item.querySelector("[data-rf-estimate-quantity]")?.value, 10) || 1); const unitPrice = !noEstimate && paper && selected && (printOnly || finishQuote) ? selected.price + (finishQuote?.price || 0) : null;
    return { paper, selected, finish, finishQuote, noEstimate, quantity, unitPrice, total: unitPrice == null ? null : unitPrice * quantity, custom, sizeLabel: custom ? `定形外 ${item.querySelector("[data-rf-custom-width]")?.value || "未定"}×${item.querySelector("[data-rf-custom-height]")?.value || "未定"}mm` : (item.querySelector("[data-rf-estimate-size]")?.value || "未定") };
  }

  syncEstimateValues() {
    const quotes = this.estimateItems().map((item) => this.itemQuote(item)); const join = (values) => values.join("、");
    const fields = { paper: this.form.querySelector("[data-rf-estimate-paper-value]"), size: this.form.querySelector("[data-rf-estimate-size-value]"), quantity: this.form.querySelector("[data-rf-estimate-quantity-value]"), finish: this.form.querySelector("[data-rf-estimate-finish-value]"), custom: this.form.querySelector("[data-rf-estimate-custom-value]"), summary: this.form.querySelector("[data-rf-estimate-summary]") };
    if (!fields.summary) return;
    fields.paper.value = join(quotes.map((q) => q.paper?.title || "未定")); fields.size.value = join(quotes.map((q) => q.sizeLabel)); fields.quantity.value = join(quotes.map((q) => `${q.quantity}枚`)); fields.finish.value = join(quotes.map((q) => q.finish || "未定"));
    const customs = quotes.filter((q) => q.custom).map((q) => `${q.sizeLabel.replace(/^定形外 /, "")}`); fields.custom.value = join(customs); fields.custom.disabled = !customs.length || this.categoryKey() !== "estimate";
    fields.summary.value = quotes.map((q, index) => {
      // 定形外は「どの規格サイズで計算したか」まで残す。担当者と返信AIが同じ根拠を見られるようにする。
      const size = q.custom && q.selected ? `${q.sizeLabel}（規格 ${q.selected.title} で計算）` : q.sizeLabel;
      const amount = q.noEstimate ? "個別にお見積り（アルミ複合板加工）" : q.total == null ? "算出できません" : formatYen(q.total);
      const item = this.estimateItems()[index]; const frame = q.finish === "額装" ? `\n額の種類：${item.querySelector("[data-rf-frame-type]")?.value || ""}\n額装の仕様：${item.querySelector("[data-rf-frame-spec]")?.value || ""}\n額の色：${item.querySelector("[data-rf-frame-color]")?.value || ""}` : ""; const aluminum = q.finish === "アルミ複合板加工" ? `\n板の色：${item.querySelector("[data-rf-aluminum-color]")?.value || ""}\nゲタ：${item.querySelector("[data-rf-aluminum-geta]")?.value || ""}` : "";
      return `${index + 1}.\n用紙：${q.paper?.title || "未定"}\nサイズ：${size}\n点数：${q.quantity}枚\n加工：${q.finish || "未定"}${frame}${aluminum}\n目安：${amount}`;
    }).join("\n");
  }

  updateBodyPlaceholder() {
    const body = this.form.querySelector('[name="contact[body]"]');
    if (body) body.placeholder = bodyPlaceholders[this.categoryKey()] || "お問い合わせ内容をご記入ください";
  }

  updateOrderTopic() {
    const topic = this.form.querySelector("[data-rf-order-topic]"); const note = this.form.querySelector("[data-rf-order-photo-note]");
    if (note) note.hidden = !topic || topic.disabled || topic.value !== "商品の不具合";
  }

  syncOrderNumber(input) {
    input.value = input.value.replace(/[０-９]/g, (character) => String.fromCharCode(character.charCodeAt(0) - 0xfee0)).replace(/\D/g, "");
    const hidden = this.form.querySelector("[data-rf-order-value]");
    if (hidden) hidden.value = input.value ? `#P${input.value}` : "";
  }

  prefill() {
    if (this.form.dataset.prefill !== "true") return;
    let text;
    try { text = sessionStorage.getItem("rf_contact_prefill"); } catch (_) { return; }
    if (!text) return;
    try { sessionStorage.removeItem("rf_contact_prefill"); } catch (_) {}
    const body = this.form.querySelector('[name="contact[body]"]');
    if (body) body.value = text;
    if (!new URLSearchParams(location.search).has("category") && /見積|定形外/.test(text)) {
      const estimate = this.categoryInputs.find((option) => option.dataset.key === "estimate");
      if (estimate) estimate.selected = true;
    }
    this.update(true);
    let moved = false;
    ["wheel", "touchstart", "keydown"].forEach((type) => addEventListener(type, () => { moved = true; }, { once: true, passive: true }));
    const align = () => {
      if (moved) return;
      const header = document.querySelector("header");
      const stickyHeight = header && ["sticky", "fixed"].includes(getComputedStyle(header).position) ? header.getBoundingClientRect().height : 0;
      scrollTo({ top: Math.max(0, this.root.getBoundingClientRect().top + scrollY - stickyHeight - 8), behavior: "auto" });
    };
    requestAnimationFrame(() => requestAnimationFrame(align));
  }

  draftValues() {
    const checked = (selector) => this.form.querySelector(`${selector}:checked`)?.value || "";
    const value = (selector) => this.form.querySelector(selector)?.value || "";
    return {
      category: this.categorySelect?.value || "",
      estimateItems: this.estimateItems().map((item) => ({ paper: item.querySelector("[data-rf-estimate-paper]")?.value || "", size: item.querySelector("[data-rf-estimate-size]")?.value || "", sizeMode: this.sizeMode(item), customWidth: item.querySelector("[data-rf-custom-width]")?.value || "", customHeight: item.querySelector("[data-rf-custom-height]")?.value || "", quantity: item.querySelector("[data-rf-estimate-quantity]")?.value || "1", finish: this.selectedFinish(item), frameType: item.querySelector("[data-rf-frame-type]")?.value || "", frameSpec: item.querySelector("[data-rf-frame-spec]")?.value || "", frameColor: item.querySelector("[data-rf-frame-color]")?.value || "", aluminumColor: item.querySelector("[data-rf-aluminum-color]")?.value || "", aluminumGeta: item.querySelector("[data-rf-aluminum-geta]")?.value || "" })),
      prefecture: value('[name="contact[配送先の都道府県]"]'),
      interestedPaper: this.paperInterestValue?.value || "",
      consideredProduct: value('[name="contact[ご検討中の商品]"]'),
      orderTopic: value('[name="contact[ご用件]"]'),
      deadline: value('[name="contact[ご希望納期]"]'),
      body: value('[name="contact[body]"]')
    };
  }

  saveDraft() {
    if (this.restoringDraft) return;
    clearTimeout(this.draftTimer);
    this.draftTimer = setTimeout(() => {
      try { localStorage.setItem(DRAFT_KEY, JSON.stringify({ savedAt: Date.now(), values: this.draftValues() })); } catch (_) {}
    }, 200);
  }

  removeDraft() {
    try { localStorage.removeItem(DRAFT_KEY); } catch (_) {}
  }

  setChecked(selector, savedValue) {
    if (!savedValue) return;
    const input = [...this.form.querySelectorAll(selector)].find((field) => field.value === savedValue);
    if (input) input.checked = true;
  }

  setValue(selector, savedValue) {
    if (typeof savedValue !== "string") return;
    const field = this.form.querySelector(selector);
    if (field && [...(field.options || [])].every((option) => option.value !== savedValue) && field.tagName === "SELECT") return;
    if (field) field.value = savedValue;
  }

  restoreDraft() {
    let draft;
    try {
      draft = JSON.parse(localStorage.getItem(DRAFT_KEY) || "null");
      if (!draft || typeof draft.savedAt !== "number" || Date.now() - draft.savedAt > DRAFT_TTL || Date.now() < draft.savedAt) {
        if (draft) localStorage.removeItem(DRAFT_KEY);
        return;
      }
    } catch (_) { return; }
    const values = draft.values;
    if (!values || typeof values !== "object") return;
    this.restoringDraft = true;
    if (this.categorySelect && typeof values.category === "string" && this.categoryInputs.some((option) => option.value === values.category)) this.categorySelect.value = values.category;
    this.update();
    const savedItems = Array.isArray(values.estimateItems) ? values.estimateItems.slice(0, ESTIMATE_ITEM_MAX) : (values.paper ? [{ paper: values.paper, size: values.size, sizeMode: values.sizeMode, customWidth: values.customWidth, customHeight: values.customHeight, quantity: values.quantity, finish: values.finish }] : []);
    this.estimateItems().slice(1).forEach((item) => item.remove());
    savedItems.slice(1).forEach((item) => this.addEstimateItem(item));
    if (savedItems[0]) { const item = this.estimateItems()[0]; item.querySelector("[data-rf-estimate-paper]").value = savedItems[0].paper || ""; this.updateSizes(item, false); if (savedItems[0].sizeMode === "custom") item.querySelector("[data-rf-size-mode][value=custom]").checked = true; this.updateSizeMode(item); item.querySelector("[data-rf-custom-width]").value = savedItems[0].customWidth || ""; item.querySelector("[data-rf-custom-height]").value = savedItems[0].customHeight || ""; item.querySelector("[data-rf-estimate-size]").value = savedItems[0].size || ""; const finish = item.querySelector("[data-rf-estimate-finish]"); if (finish && [...finish.options].some((option) => option.value === savedItems[0].finish)) finish.value = savedItems[0].finish; this.restoreFrameFields(item, savedItems[0]); this.restoreAluminumFields(item, savedItems[0]); }
    this.setValue('[name="contact[配送先の都道府県]"]', values.prefecture);
    this.restorePaperInterest(values.interestedPaper);
    this.setValue('[name="contact[ご検討中の商品]"]', values.consideredProduct);
    this.setValue('[name="contact[ご用件]"]', values.orderTopic); this.updateOrderTopic();
    this.setValue('[name="contact[ご希望納期]"]', values.deadline);
    this.setValue('[name="contact[body]"]', values.body);
    this.restoringDraft = false;
    this.update();
    this.syncEstimateValues();
    // 種類を選んだだけでも下書きは保存されるので、それだけで「復元しました」と出すと
    // 何も入れていないのに毎回出て邪魔になる。中身が戻った時だけ知らせる。
    if (this.draftNotice) this.draftNotice.hidden = !hasRestorableInput(values);
  }

  restorePaperInterest(saved) {
    if (typeof saved !== "string" || !saved || !this.paperInterestList) return;
    const wanted = saved.split("、").map((item) => item.trim()).filter(Boolean).filter((item) => item !== "未定").slice(0, PAPER_INTEREST_MAX);
    if (!wanted.length) return;
    this.paperInterestList.querySelectorAll("[data-rf-paper-interest-row]").forEach((row, index) => { if (index) row.remove(); });
    const first = this.paperInterestSelects()[0];
    if (first && [...first.options].some((option) => option.value === wanted[0])) first.value = wanted[0];
    wanted.slice(1).forEach((item) => this.addPaperInterestRow(item));
    this.syncPaperInterest();
  }

  clearDraftValues() {
    this.removeDraft();
    if (this.categorySelect) this.categorySelect.selectedIndex = 0;
    ["[data-rf-custom-width]", "[data-rf-custom-height]", '[name="contact[ご検討中の商品]"]', '[name="contact[ご希望納期]"]', '[name="contact[body]"]'].forEach((selector) => {
      const field = this.form.querySelector(selector);
      if (field) field.value = field.defaultValue;
    });
    this.form.querySelectorAll('[name="contact[お客様区分]"], [data-rf-size-mode]').forEach((field) => { field.checked = field.defaultChecked; });
    this.paperInterestList?.querySelectorAll("[data-rf-paper-interest-row]").forEach((row, index) => { if (index) row.remove(); });
    this.estimateItems().slice(1).forEach((item) => item.remove());
    const estimate = this.estimateItems()[0];
    if (estimate) { estimate.querySelector("[data-rf-estimate-paper]").selectedIndex = 0; estimate.querySelector("[data-rf-estimate-quantity]").value = "1"; estimate.querySelector("[data-rf-size-mode][value=standard]").checked = true; estimate.querySelectorAll("[data-rf-custom-width], [data-rf-custom-height]").forEach((field) => { field.value = ""; }); estimate.querySelector("[data-rf-estimate-finish]").selectedIndex = 0; this.updateFrameFields(estimate); this.updateAluminumFields(estimate, true); this.updateSizes(estimate); }
    [...this.paperInterestSelects(), this.form.querySelector('[name="contact[配送先の都道府県]"]'), this.form.querySelector("[data-rf-order-topic]")].filter(Boolean).forEach((field) => { field.selectedIndex = 0; });
    this.syncPaperInterest();
    if (this.draftNotice) this.draftNotice.hidden = true;
    this.update();
  }

  updateInputSummary() {
    if (!this.inputSummary) return;
    const category = this.categoryInput();
    const toggle = this.form.querySelector("[data-rf-summary-toggle]");
    if (toggle) { toggle.hidden = !category || category.dataset.key !== "estimate"; toggle.textContent = this.summaryOpened ? "入力内容を確認する ▴" : "入力内容を確認する ▾"; }
    if (!category || category.dataset.key === "other") { this.inputSummary.hidden = true; this.inputSummary.replaceChildren(); return; }
    const rows = [["お問い合わせ内容", category.value], ["お客様区分", this.typeValue()]];
    const choices = [];
    this.form.querySelectorAll('[data-rf-block="customer"] select:not(:disabled), [data-rf-block="details"] select:not(:disabled), [data-rf-block="details"] input:checked:not(:disabled)').forEach((field) => {
      if (!field.value || field.hasAttribute("data-rf-size-mode") || field.type === "checkbox") return;
      const name = (field.name || "").replace(/^contact\[|\]$/g, "");
      if (name && name !== "お問い合わせ内容" && !choices.some(([label]) => label === name)) choices.push([name, field.value]);
    });
    // 見積の品目は hidden に name を持たせていない（メールで重複するため）。
    // 送信前の確認には出す必要があるので、品目ごとに1行足す。
    if (this.categoryKey() === "estimate") {
      this.estimateItems().forEach((item, index) => {
        const quote = this.itemQuote(item);
        const parts = [quote.paper?.title || "未定", quote.sizeLabel, `${quote.quantity}枚`, quote.finish || "未定"];
        if (quote.finish === "額装") parts.push(...["[data-rf-frame-type]", "[data-rf-frame-spec]", "[data-rf-frame-color]"].map((selector) => item.querySelector(selector)?.value || "未選択"));
        if (quote.finish === "アルミ複合板加工") parts.push(...["[data-rf-aluminum-color]", "[data-rf-aluminum-geta]"].map((selector) => item.querySelector(selector)?.value || "未選択"));
        if (quote.total != null) parts.push(`目安 ${formatYen(quote.total)}`);
        choices.push([`品目${index + 1}`, parts.join(" / ")]);
      });
    }
    const quoteDoc = this.form.querySelector("[data-rf-quote-doc]:checked:not(:disabled)");
    if (quoteDoc) choices.push(["見積書の発行", quoteDoc.value]);
    const interested = this.paperInterestValue && !this.paperInterestValue.disabled ? this.paperInterestValue.value : "";
    if (interested && interested !== "未定") choices.push(["気になっている用紙", interested]);
    rows.push(...choices.slice(0, 10));
    rows.push(["添付件数", `${this.files.length}件`]);
    rows.push(["返信先メールアドレス", this.form.querySelector('[name="contact[email]"]')?.value || "未入力"]);
    const title = document.createElement("p");
    title.className = "rf-inq-input-summary-title";
    title.textContent = "入力内容の確認";
    const list = document.createElement("dl");
    rows.forEach(([label, content]) => {
      const term = document.createElement("dt");
      const description = document.createElement("dd");
      term.textContent = label;
      description.textContent = content;
      list.append(term, description);
    });
    this.inputSummary.replaceChildren(title, list);
    this.inputSummary.hidden = category.dataset.key === "estimate" && !this.summaryOpened;
  }

  async getFirebase() {
    if (this.fb) return this.fb;
    const { initializeApp, getApps, getAuth, signInAnonymously, getStorage, ref, uploadBytesResumable, getDownloadURL } = await loadFirebase();
    this.fbApi = { ref, uploadBytesResumable, getDownloadURL };
    const app = getApps().find((candidate) => candidate.name === "rf-inquiry") || initializeApp(firebaseConfig, "rf-inquiry");
    const auth = getAuth(app);
    const credential = await signInAnonymously(auth);
    this.fb = { storage: getStorage(app), uid: credential.user.uid };
    return this.fb;
  }

  setUploadError(message) {
    if (!this.uploadError) return;
    this.uploadError.textContent = message;
    this.uploadError.hidden = !message;
  }

  async addFiles(rawFiles) {
    this.setUploadError("");
    const incoming = Array.from(rawFiles || []);
    this.fileInput.value = "";
    for (const file of incoming) {
      const extension = (file.name.split(".").pop() || "").toLowerCase();
      if (!allowed.has(extension)) { this.setUploadError(`${file.name} は対応していない形式です。`); continue; }
      if (file.size > maxBytes) { this.setUploadError(`${file.name} は500MBを超えているため追加できません。`); continue; }
      if (this.files.length >= 10) { this.setUploadError("添付は最大10点までです。"); break; }
      const item = { file, status: "waiting", progress: 0, id: `${Date.now()}-${Math.random()}` };
      this.files.push(item);
      this.renderFiles();
      this.upload(item);
    }
  }

  async upload(item) {
    try {
      const fb = await this.getFirebase();
      item.status = "uploading";
      this.renderFiles();
      const timestamp = Math.max(Date.now(), lastTimestamp + 1);
      lastTimestamp = timestamp;
      const { ref, uploadBytesResumable, getDownloadURL } = this.fbApi;
      const task = uploadBytesResumable(ref(fb.storage, `uploads/${fb.uid}/inquiry/${timestamp}_${safeName(item.file.name)}`), item.file);
      item.task = task;
      await new Promise((resolve, reject) => task.on("state_changed", (snapshot) => {
        item.progress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100);
        this.renderFiles();
      }, reject, resolve));
      item.url = await getDownloadURL(task.snapshot.ref);
      item.status = "done";
      item.progress = 100;
      this.syncAttachments();
      this.renderFiles();
    } catch (_) {
      item.status = "failed";
      this.setUploadError(this.fb ? "アップロードに失敗しました。再試行してください。" : "添付の準備に失敗しました。共有URL欄をご利用ください。");
      this.renderFiles();
    }
  }

  syncAttachments() {
    const done = this.files.filter((item) => item.status === "done");
    this.attachments.disabled = done.length === 0;
    this.attachments.value = done.map((item, index) => `${index + 1}. ${item.file.name} (${fileSize(item.file.size)})\n${item.url}`).join("\n");
  }

  removeFile(item) {
    item.task?.cancel();
    if (item.thumbUrl) { try { URL.revokeObjectURL(item.thumbUrl); } catch (_) {} item.thumbUrl = ""; }
    this.files = this.files.filter((candidate) => candidate !== item);
    this.syncAttachments();
    this.renderFiles();
  }

  thumbFor(item) {
    // 本家の注文フォームと同じ 48px サムネイル。画像以外は拡張子を出す。
    const ext = (item.file.name.split(".").pop() || "").toLowerCase();
    if (["jpg", "jpeg", "png", "webp", "gif"].includes(ext)) {
      if (!item.thumbUrl) { try { item.thumbUrl = URL.createObjectURL(item.file); } catch (_) { item.thumbUrl = ""; } }
      if (item.thumbUrl) {
        const img = document.createElement("img");
        img.className = "rf-file-thumb";
        img.src = item.thumbUrl;
        img.alt = "";
        return img;
      }
    }
    const box = document.createElement("span");
    box.className = "rf-file-thumb rf-inq-file-thumb-ext";
    box.textContent = ext ? ext.toUpperCase().slice(0, 4) : "FILE";
    return box;
  }

  renderFiles() {
    if (!this.fileList) return;
    this.fileList.replaceChildren(...this.files.map((item) => {
      const row = document.createElement("div");
      row.className = `rf-file-item${item.status === "done" ? " rf-upload-complete" : ""}`;
      row.style.setProperty("--progress", `${item.progress || 0}%`);
      const info = document.createElement("div");
      info.className = "rf-file-info";
      const thumb = this.thumbFor(item);
      if (thumb) info.append(thumb);
      const details = document.createElement("div");
      details.className = "rf-file-details";
      const name = document.createElement("span");
      name.className = "rf-file-name";
      name.textContent = item.file.name;
      const size = document.createElement("span");
      size.className = "rf-file-size";
      size.textContent = fileSize(item.file.size);
      const progress = document.createElement("span");
      progress.className = "rf-inq-file-progress";
      progress.textContent = item.status === "done" ? "✓ 完了" : item.status === "failed" ? "アップロード失敗" : item.status === "waiting" ? "準備中" : `${item.progress || 0}%`;
      details.append(name, size);
      info.append(details);
      const actions = document.createElement("div");
      actions.className = "rf-file-meta rf-inq-file-actions";
      actions.append(progress);
      if (item.status === "failed") {
        const retry = document.createElement("button");
        retry.type = "button";
        retry.className = "rf-inq-file-action rf-inq-file-retry";
        retry.textContent = "再試行";
        retry.addEventListener("click", () => this.upload(item));
        actions.append(retry);
      }
      const remove = document.createElement("button");
      remove.type = "button";
      remove.className = "rf-file-remove rf-inq-file-action";
      remove.textContent = "×";
      remove.setAttribute("aria-label", `${item.file.name} を除外`);
      remove.addEventListener("click", () => this.removeFile(item));
      actions.append(remove);
      row.append(info, actions);
      return row;
    }));
    this.updateUploadingState();
    this.updateInputSummary();
  }

  updateUploadingState() {
    const uploading = this.files.some((item) => item.status === "waiting" || item.status === "uploading");
    if (this.submitButton) this.submitButton.disabled = uploading;
    if (this.submitLabel) this.submitLabel.textContent = uploading ? "アップロードが終わるまでお待ちください" : "この内容で送信する";
  }

  validationKey(field) {
    return field?.dataset?.rfErrorKey || field?.getAttribute?.("name") || field?.id || "";
  }

  validationFields(field) {
    if (!(field instanceof Element)) return [];
    const key = this.validationKey(field);
    if (key === "custom-size") return [...field.closest("[data-rf-estimate-item]")?.querySelectorAll('[data-rf-error-key="custom-size"]:not(:disabled)') || []];
    if (field.name) return [...this.form.querySelectorAll(`[name="${CSS.escape(field.name)}"]:not(:disabled)`)];
    return [field];
  }

  fieldIsValid(field) {
    const fields = this.validationFields(field);
    return fields.length === 0 || fields.every((item) => item.checkValidity());
  }

  handleFieldChange(field) {
    const key = this.validationKey(field);
    if (key && this.form.querySelector(`[data-rf-error-for="${CSS.escape(key)}"]`) && this.fieldIsValid(field)) this.clearFieldError(field);
    this.saveDraft();
    this.updateInputSummary();
  }

  clearStaleFormQuery() {
    // 送信は POST なので、URL のクエリに form_type=contact が乗っているのは「送信の結果」ではない。
    // その状態のページは開くたびに Shopify がエラー（メール未入力など）を出し、
    // 同じページの全フォーム（フッターのメルマガ登録を含む）に帯が出る。
    // 読み込んだ時点でクエリを落として、再読み込みしても再発しないようにする。
    let params;
    try { params = new URLSearchParams(location.search); } catch (_) { return false; }
    if (params.get("form_type") !== "contact") return false;
    const keep = new URLSearchParams();
    params.forEach((value, key) => { if (!key.startsWith("contact[") && key !== "form_type") keep.append(key, value); });
    const query = keep.toString();
    try { history.replaceState(null, "", location.pathname + (query ? `?${query}` : "") + location.hash); } catch (_) {}
    return true;
  }

  setupFormError() {
    // Shopify が送信を弾いた時の帯。該当の欄へ案内し、直したら消す。
    // 帯は次に送信するまでページを開き直しても残るので、消せないと「ずっと出ている」ように見える。
    const banner = this.form.querySelector("[data-rf-form-error]");
    if (!banner) return;
    if (this.clearStaleFormQuery()) { banner.remove(); return; }
    const key = banner.dataset.rfErrorField || "";
    const field = key === "email" ? this.form.querySelector('[name="contact[email]"]') : null;
    if (field) {
      field.classList.add("rf-input-error");
      field.setAttribute("aria-invalid", "true");
      requestAnimationFrame(() => this.scrollToField(field));
      const clear = () => {
        banner.hidden = true;
        field.classList.remove("rf-input-error");
        field.removeAttribute("aria-invalid");
      };
      field.addEventListener("input", clear, { once: true });
    }
    const close = document.createElement("button");
    close.type = "button";
    close.className = "rf-inq-form-error-close";
    close.setAttribute("aria-label", "この通知を閉じる");
    close.textContent = "×";
    close.addEventListener("click", () => { banner.hidden = true; });
    banner.append(close);
  }

  normalizeText(field) {
    // 日本語入力のまま打つと ＠ や英数字が全角で入り、Shopify 側で「無効です」になる。
    // 全角の記号・英数字を半角へ直し、メールと URL からは空白を落とす。
    if (!(field instanceof HTMLInputElement)) return;
    if (!["email", "url", "tel"].includes(field.type) && field.dataset.rfNormalizeText === undefined) return;
    const before = field.value;
    let after = before.replace(/[\uFF01-\uFF5E]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 0xFEE0)).replace(/\u3000/g, " ");
    after = field.type === "tel" || field.dataset.rfNormalizeText !== undefined ? after.trim() : after.replace(/\s+/g, "");
    if (after !== before) field.value = after;
  }

  validateOnBlur(field) {
    if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement)) return;
    if (field.disabled || field.type === "hidden" || field.type === "file" || field.dataset.rfHoneypot !== undefined) return;
    this.normalizeText(field);
    if (!this.fieldIsValid(field)) this.renderFieldError(field);
  }

  clearFieldError(field) {
    if (!(field instanceof Element)) return;
    const targets = this.validationFields(field);
    targets.forEach((target) => { target.classList.remove("rf-input-error"); target.removeAttribute("aria-invalid"); });
    const wrapper = field.closest(".rf-radio-group, .rf-radio-group-horizontal, .rf-input-group, .rf-checkbox-label");
    wrapper?.classList.remove("rf-input-error");
    const errorKey = this.validationKey(field);
    const error = errorKey && this.form.querySelector(`[data-rf-error-for="${CSS.escape(errorKey)}"]`);
    if (error) { error.hidden = true; error.textContent = ""; }
    this.syncErrorSummaryFromVisibleErrors();
  }

  validationMessage(field) {
    const key = this.validationKey(field);
    if (key === "custom-size") return "幅と高さを半角数字でご入力ください";
    if (field.type === "email" && field.validity.typeMismatch) return "メールアドレスの形式をご確認ください（例：name@example.com）";
    if (field.validity.patternMismatch || field.validity.badInput || field.validity.stepMismatch) return `${this.fieldLabel(field)}を半角数字でご入力ください`;
    const label = this.fieldLabel(field);
    if (field.type === "radio" || field.type === "checkbox" || field.tagName === "SELECT") return `${label}を選択してください`;
    return `${label}を入力してください`;
  }

  fieldLabel(field) {
    if (field.name === "contact[name]") return "お名前";
    if (field.name === "contact[email]") return "メールアドレス";
    const item = field.closest("[data-rf-estimate-item]");
    const prefix = item && this.estimateItems().length > 1 ? `品目${this.estimateItems().indexOf(item) + 1}の` : "";
    if (this.validationKey(field) === "custom-size") return `${prefix}幅と高さ`;
    const group = field.closest(".rf-input-group");
    const label = (field.id && this.form.querySelector(`label[for="${CSS.escape(field.id)}"]`)) || group?.querySelector(".rf-label, .rf-checkbox-text");
    const text = label?.textContent?.replace(/\s*[※*]\s*|（任意）/g, " ").trim();
    if (text) return `${prefix}${text.split("注意点を読む")[0].trim()}`;
    return (field.name || field.getAttribute("aria-label") || "必須項目").replace(/^contact\[|\]$/g, "");
  }

  ensureErrorNode(field) {
    const key = this.validationKey(field);
    let error = this.form.querySelector(`[data-rf-error-for="${CSS.escape(key)}"]`);
    if (error) return error;
    error = document.createElement("div");
    error.className = "rf-error-msg";
    error.dataset.rfErrorFor = key;
    error.hidden = true;
    const wrapper = field.closest(".rf-radio-group, .rf-radio-group-horizontal, .rf-input-group, .rf-checkbox-label") || field;
    wrapper.insertAdjacentElement("afterend", error);
    return error;
  }

  renderFieldError(field) {
    const fields = this.validationFields(field);
    fields.forEach((item) => { item.classList.add("rf-input-error"); item.setAttribute("aria-invalid", "true"); });
    const wrapper = field.closest(".rf-radio-group, .rf-radio-group-horizontal, .rf-input-group, .rf-checkbox-label") || field;
    wrapper.classList.add("rf-input-error");
    const error = this.ensureErrorNode(field);
    error.textContent = this.validationMessage(field);
    error.hidden = false;
    return error;
  }

  renderValidationErrors() {
    this.form.querySelectorAll("[data-rf-error-for]").forEach((node) => { node.hidden = true; node.textContent = ""; });
    this.form.querySelectorAll(".rf-input-error").forEach((node) => { node.classList.remove("rf-input-error"); node.removeAttribute("aria-invalid"); });
    const invalid = [...this.form.elements].filter((field) => !field.disabled && !field.checkValidity());
    const renderedNames = new Set();
    invalid.forEach((field) => {
      const key = this.validationKey(field);
      if (renderedNames.has(key)) return;
      renderedNames.add(key);
      this.renderFieldError(field);
    });
    this.renderErrorSummary(invalid);
    return invalid;
  }

  errorTarget(field) {
    const fields = this.validationFields(field);
    const target = fields[0] || field;
    if (!target.id) target.id = `rf-error-target-${Math.random().toString(36).slice(2, 10)}`;
    return target.id;
  }

  renderErrorSummary(invalid) {
    if (!this.errorSummary) return;
    const unique = [];
    const keys = new Set();
    invalid.forEach((field) => {
      const key = this.validationKey(field);
      if (!keys.has(key)) { keys.add(key); unique.push(field); }
    });
    if (!unique.length) { this.errorSummary.hidden = true; this.errorSummary.replaceChildren(); return; }
    const title = document.createElement("p");
    title.textContent = "入力内容をご確認ください";
    const list = document.createElement("ul");
    unique.forEach((field) => {
      const item = document.createElement("li");
      const link = document.createElement("a");
      link.href = `#${this.errorTarget(field)}`;
      link.textContent = this.fieldLabel(field);
      item.append(link);
      list.append(item);
    });
    this.errorSummary.replaceChildren(title, list);
    this.errorSummary.hidden = false;
  }

  syncErrorSummaryFromVisibleErrors() {
    if (!this.errorSummary || this.errorSummary.hidden) return;
    const invalid = [...this.form.elements].filter((field) => !field.disabled && !field.checkValidity());
    if (invalid.length) this.renderErrorSummary(invalid);
    else { this.errorSummary.hidden = true; this.errorSummary.replaceChildren(); }
  }

  scrollToField(field, focus = true) {
    const section = field.closest("[data-rf-block]") || field;
    const header = document.querySelector("header");
    const stickyHeight = header && ["sticky", "fixed"].includes(getComputedStyle(header).position) ? header.getBoundingClientRect().height : 0;
    const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;
    scrollTo({ top: Math.max(0, section.getBoundingClientRect().top + scrollY - stickyHeight - 16), behavior: reducedMotion ? "auto" : "smooth" });
    if (focus) setTimeout(() => field.focus({ preventScroll: true }), reducedMotion ? 0 : 350);
  }

  submit(event) {
    this.form.querySelectorAll('input[type="email"], input[type="url"], input[type="tel"], input[data-rf-normalize-text]').forEach((field) => this.normalizeText(field));
    this.submitError.hidden = true;
    this.submitError.textContent = "";
    if (this.form.querySelector("[data-rf-honeypot]")?.value) {
      event.preventDefault();
      return;
    }
    if (this.files.some((item) => item.status === "waiting" || item.status === "uploading")) {
      event.preventDefault();
      this.submitError.textContent = "アップロードが終わるまでお待ちください";
      this.submitError.hidden = false;
      this.scrollToField(this.form.querySelector("[data-rf-dropzone]"));
      return;
    }
    const invalid = this.renderValidationErrors();
    if (invalid.length) {
      event.preventDefault();
      this.submitError.textContent = "未入力の必須項目をご確認ください。";
      this.submitError.hidden = false;
      this.scrollToField(invalid[0], false);
      this.errorSummary?.focus({ preventScroll: true });
      return;
    }
    if (typeof window.gtag === "function") {
      window.gtag("event", "inquiry_submit", { inquiry_category: this.categoryKey(), inquiry_customer_type: this.typeValue() === "法人・団体のお客様" ? "corporate" : "individual", inquiry_attachments: this.files.filter((item) => item.status === "done").length });
    }
  }
}

function init(scope = document) {
  scope.querySelectorAll("[data-rf-inquiry-form]").forEach((form) => {
    if (!form.dataset.rfReady) { form.dataset.rfReady = "true"; new InquiryForm(form); }
  });
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => init());
else init();
document.addEventListener("shopify:section:load", (event) => init(event.target));
